import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import '../../css/homepage.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import failedImage from '../../images/payment-failed.png'; // Make sure this exists

function PaymentFailed() {
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (!storedUserId) {
      navigate("/"); // Redirect to login if not logged in
    }
  }, [navigate]);

  const handleGoHome = () => {
    navigate("/loginsubmit");
  };

  return (
    <div className="container-fluid p-0" style={{ backgroundColor: '#f8f8f8', minHeight: '100vh' }}>
      {/* Payment Failure Content */}
      <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ padding: '80px 20px' }}>
        <img src={failedImage} alt="Payment Failed" className="img-fluid mb-4" style={{ maxWidth: '150px' }} />
        <h2 className="mb-3" style={{ color: '#5F259F' }}>Payment Failed</h2>
        <p className="text-muted mb-4">Unfortunately, your payment could not be processed. Please try again later.</p>
        <button className="btn btn-primary" style={{ backgroundColor: '#5F259F', border: 'none' }} onClick={handleGoHome}>
          Return to Home
        </button>
      </div>
    </div>
  );
}

export default PaymentFailed;
